/* this file added by Bearer Web Developer  */
import React, { useRef } from "react";
import { useAppState } from "../../../../states/app-state";
import BearerSearchField from "./BearerSearchField";
import styles from './search.module.scss';
import ItemsMenu from "./itemsMenu";
import { observer } from "mobx-react-lite";
import { useThemeMode } from "../../../../states/contexts/theme";
const Search: React.FC = observer(() => {
    const appState = useAppState();
    const { search, setSearch, searchItems } = appState.ReservedOrders;
    const onChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
    };
    const parentRef = useRef(null);
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    const selectedAll = searchItems?.destination_address && searchItems?.destination_details && searchItems?.client_order_number && searchItems?.recipient_name && searchItems?.recipient_phone_number;
    return (
        <div className={styles.search_part}  data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <div ref={parentRef} className={`${styles.search} ${!selectedAll ? styles.not_selected_all : ''}`}>
                <BearerSearchField
                    name='Search'
                    placeholder={"Search"}
                    value={search}
                    onChange={onChangeSearch}
                    clear={() => setSearch('')} // added by Bearer Web Developer
                />
                <ItemsMenu parentRef={parentRef} />
            </div>
        </div>
    )
})
export default Search;